import { FC, useContext, useMemo } from 'react';

import { AddonsContext } from 'contexts/addons';

import { ScRegPayments, ScRegPaymentsProps } from './styled';

export const RegPayments: FC<ScRegPaymentsProps> = (props) => {
  const { cmsPaymentMethods } = useContext(AddonsContext);

  const regFormPaymentMethodsLogos = useMemo(() => {
    if (!cmsPaymentMethods) return [];

    const { depositMethods, withdrawMethods } = cmsPaymentMethods;

    return [
      ...(depositMethods?.methods || []),
      ...(withdrawMethods?.methods || []),
    ]
      .filter(({ registrationForm }) => registrationForm)
      .map(({ imageGrayscale }) => ({ src: imageGrayscale.url }));
  }, [cmsPaymentMethods]);

  return regFormPaymentMethodsLogos.length ? (
    <ScRegPayments {...props}>
      {regFormPaymentMethodsLogos.map(({ src }) => (
        <img src={src} key={src} alt="payment logo" />
      ))}
    </ScRegPayments>
  ) : null;
};
